module.exports = __webpack_public_path__ + "img/page_item1.39316caa.png";